import { config as envConfig } from 'ENV_CONFIG';
import { services } from '~/ocab-services/services.constant';
import {store} from "~/store";

export const getAppointmentsDetails = (appointmentType) => {
  const piercingType = store?.getState()?.appointment?.draft?.piercingType;
  let appointmentDetails = {
    journey: envConfig.services[services.PIERCING.name]?.analyticsJourneyName || 'piercing',
    piercingType: piercingType,
    branchId: '',
  };
  if (appointmentType.id) {
    appointmentDetails = {
      ...appointmentDetails,
      ...window?.jlData?.page?.appointments
    }
  }
  return appointmentDetails;
};
